import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { XCircle } from "lucide-react";

const SubscriptionCancel = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="max-w-md w-full bg-white rounded-3xl border border-orange-100/50 p-8 text-center space-y-6">
        <div className="w-20 h-20 rounded-full bg-orange-50 mx-auto flex items-center justify-center">
          <XCircle className="w-10 h-10 text-muted-foreground" />
        </div>
        <div>
          <h1 className="font-heading text-2xl font-bold text-secondary">{t('subscription.checkout_cancelled')}</h1>
          <p className="text-muted-foreground mt-2">
            {t('subscription.no_worries')}
          </p>
        </div>
        <div className="bg-orange-50 rounded-2xl p-4">
          <p className="text-sm text-secondary">
            <strong>{t('subscription.free_plan_includes')}</strong>
          </p>
          <ul className="text-sm text-muted-foreground mt-2 space-y-1">
            <li>{t('subscription.free_meal_analyses')}</li>
            <li>{t('subscription.free_lana_questions')}</li>
            <li>{t('subscription.free_glucose_logging')}</li>
            <li>{t('subscription.free_meal_history')}</li>
          </ul>
        </div>
        <Button
          onClick={() => navigate("/dashboard")}
          className="w-full rounded-full bg-primary text-white hover:bg-primary/90 py-6 font-bold"
        >
          {t('subscription.back_to_dashboard')}
        </Button>
      </Card>
    </div>
  );
};

export default SubscriptionCancel;
